import {capitalize} from '@resurs-internal/rb-app-api';
import {maskAccountNumber} from './maskAccountNumber';
import {DepositAccountPreview} from '@resurs-internal/rb-app-api/api/customer-frontend-service';

export const getDepositAccountLabel = (
  account: DepositAccountPreview,
  customerName: string,
  accountBalance: string,
) => {
  const accountNumber =
    account?.accountNumber?.number || account?.accountNumber?.reference
      ? `(${maskAccountNumber(
          account?.accountNumber?.number ??
            account?.accountNumber?.reference ??
            '',
        )})`
      : '';

  const accountholderName =
    customerName?.toLowerCase() !== account?.accountHolderName?.toLowerCase()
      ? capitalize(account?.accountHolderName)
      : '';

  return `${account.name} ${accountNumber} ${accountholderName} (${accountBalance})`;
};
